import { QESAlert } from "@app/shared/qes-standards/Alert";
import { QESButton } from "@app/shared/qes-standards/Button";
import { FC } from "react";

interface RunReviewBannerProps {
  eligibleCount: number;
  runningCount: number;
  onReview: () => void;
}

export const RunReviewBanner: FC<RunReviewBannerProps> = ({ eligibleCount, runningCount, onReview }) => {
  if (eligibleCount === 0 && runningCount === 0) return null;
  return (
    <div>
      <QESAlert classNames="market-nightly-refresh__run-review" type="info" persist={false}>
        <span>
          Override-to-include changes detected:{" "}
          {runningCount > 0 && <>{<strong>{runningCount}</strong>} {runningCount === 1 ? "set" : "sets"} already running</>}
          {runningCount > 0 && eligibleCount > 0 && ", "}
          {eligibleCount > 0 && <>{<strong>{eligibleCount}</strong>} {eligibleCount === 1 ? "set" : "sets"} ready to run</>}
          .{" "}Review to run eligible sets now.
        </span>
        <div className="market-nightly-refresh__run-review-buttons">
          <QESButton qesType="secondary" onClick={onReview} qesTestId="mnr-run-review-banner__review">Review</QESButton>
        </div>
      </QESAlert>
    </div>
  )
}
